module.exports = __webpack_public_path__ + "static/media/Calculator2.9426a2ce.svg";